export function getDateTime(value) {
    var d = new Date(value);
    if (isNaN(d.getMonth())) {
        var t = value.split(/[- T:+-]/);
        console.log(t);
        // Apply each element to the Date function
        d = new Date(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
    }
    return d;
}

export function pad(s) {
    return s < 10 ? '0' + s : s;
}

export function formatDateTime(string) {
    var d = getDateTime(string);
    return [pad(d.getHours()), pad(d.getMinutes(), pad(d.getSeconds()))].join(':');
}

export function formatDate(string) {
    var d = getDateTime(string);
    return [pad(d.getFullYear()), pad(d.getMonth() + 1), pad(d.getDate())].join('-');
}

export function percentage(final, actual, init) {
    if (!final) return 100;
    if (!actual || !init) {
        return 0;
    }

    const t1 = getDateTime(final);
    const t2 = getDateTime(init);
    const t3 = getDateTime(actual);
    const total = (t1.getTime() - t2.getTime()) / 1000;
    const dif = (t1.getTime() - t3.getTime()) / 1000;

    if (dif <= 0) return 100;
    else return 100 - (dif * 100) / total;
}

export function timeDiference(final, actual) {
    if (actual > final || !actual || !final) {
        return '00 s';
    } else {
        const finalTime = getDateTime(final).getTime();
        const initialTime = getDateTime(actual).getTime();
        let totalSeconds = (finalTime - initialTime) / 1000; // this is a time in seconds
        const hours = Math.floor(totalSeconds / 3600);
        totalSeconds %= 3600;
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        if (hours > 24) {
            return Math.floor(hours / 24) + ' d';
        } else if (hours === 0 && minutes === 0) {
            return pad(seconds) + ' s';
        } else {
            return pad(hours) + ':' + pad(minutes);
        }
    }
}

export function getCurrentTime() {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();
    return (
        yyyy +
        '-' +
        mm +
        '-' +
        dd +
        ' ' +
        pad(today.getHours()) +
        ':' +
        pad(today.getMinutes()) +
        ':' +
        pad(today.getSeconds())
    );
}

export function minutosHHMM(n) {
    var num = n;
    var hours = num / 60;
    var rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);
    return pad(rhours) + ':' + pad(rminutes);
}

export function getTotalSecondsDiference(final, actual) {
    if (actual > final || !actual || !final) {
        return 0;
    } else {
        return (getDateTime(final).getTime() - getDateTime(actual).getTime()) / 1000; // this is a time in seconds
    }
}



// WEBPACK FOOTER //
// ./src/functions/time.js